import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TInspectionTask } from '../types/types'

const initialState:
    {
        inspectionTask: TInspectionTask[]

    } = {
    inspectionTask: []
}

const InspectionTask = createSlice({
    name: 'inspectionTask',
    initialState,
    reducers: {
        addInspectionTask: (state, action: PayloadAction<TInspectionTask[]>) => {
            state.inspectionTask = action.payload
        },
        addSingleTask: (state, action: PayloadAction<TInspectionTask>) => {
            state.inspectionTask.push(action.payload);
        },
        removeSingleTask: (state, action: PayloadAction<number>) => {
            state.inspectionTask = state.inspectionTask.filter(t => t.inspectionTaskId !== action.payload);
        },
    },
});

export const { addInspectionTask, addSingleTask, removeSingleTask } = InspectionTask.actions;

export default InspectionTask.reducer;
